import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { BRAND_LOGO } from '@/shared/constants/app/brand.ts';
import {
  FOOTER_LEGAL,
  footerSmallNavigation,
} from '@/shared/constants/app/footerNavigation.ts';

import { FOOTER_TONE } from './footer.constant';

/**
 * 푸터 조각들.
 *
 * 화면마다 푸터의 **구성**은 달라도(사업자 정보 전체 / 도움말용 간략) 링크 목록과
 * 카피라이트 줄은 같아야 한다. 각자 복사하면 약관 링크가 한쪽에서만 바뀐다.
 */

/** 가운뎃점 구분자. */
export function FooterDot() {
  return (
    <span aria-hidden className={FOOTER_TONE.dot}>
      ·
    </span>
  );
}

/** 회사소개·약관·개인정보처리방침 등 필수 링크 줄. */
export function FooterLegalNav({ className = '' }: { className?: string }) {
  return (
    <nav
      className={`flex flex-wrap items-center gap-x-4 gap-y-2 text-[13px] font-medium ${className}`}
    >
      {footerSmallNavigation.map((row, i) => (
        <Fragment key={row.id}>
          {i > 0 && (
            <span aria-hidden className={`h-3 w-px ${FOOTER_TONE.navDivider}`} />
          )}
          <Link
            to={row.path}
            target={row.target}
            rel={row.target === '_blank' ? 'noopener noreferrer' : undefined}
            className={`transition-colors ${row.strong ? FOOTER_TONE.navLinkStrong : FOOTER_TONE.navLink}`}
          >
            {row.label}
          </Link>
        </Fragment>
      ))}
    </nav>
  );
}

/** 로고 + 카피라이트 한 줄. 푸터의 마지막 줄은 어디서나 같다. */
export function FooterCopyright({ className = '' }: { className?: string }) {
  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-2 ${FOOTER_TONE.rule} pt-5 ${className}`}
    >
      <img
        className={`h-7 w-auto ${FOOTER_TONE.logo}`}
        loading="lazy"
        alt={BRAND_LOGO.name}
        src={BRAND_LOGO.svg}
      />
      <span className={`text-[12px] ${FOOTER_TONE.copyright}`}>
        {FOOTER_LEGAL.copyright}
      </span>
    </div>
  );
}
